export default __webpack_public_path__ + "static/media/logo.530e22df.png";